import React, { useEffect } from 'react';
import WaitingForIncidentMessage from '../shared/IncidentWidgets/WaitingForIncidentMessage';
import { connect } from 'react-redux';
import { selectCurrentDisplayedIncident } from '../../../../state/modules/incidents/selectors';
import { IncidentContainer } from '../../../general/UnderstaffingWarning';

const IncidentCrewingWarnings = ({ dashboardAPIManager, groupId, displayedIncident, groups, skills }) => {
  useEffect(() => {
    dashboardAPIManager.fetchSkills();
    dashboardAPIManager.fetchGroupAndSubgroups();
  }, [dashboardAPIManager]);

  const incident = displayedIncident;
  const group = groups.byId[groupId];
  if (!group || !skills.lastFetch || !incident) return <WaitingForIncidentMessage />;

  return (
    <IncidentContainer
      key={incident.id}
      incident={incident}
      skills={skills}
      groups={[group]}
      hideHeader={true}
      showAllStatuses={true}
    />
  );
};

const mapStateToProps = state => ({
  displayedIncident: selectCurrentDisplayedIncident(state),
  groups: state.groups,
  skills: state.skills
});

export default connect(mapStateToProps)(IncidentCrewingWarnings);
